/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 8051ff62d868
 */

import * as z from "zod";
import { transformationsUpdateTransformation } from "../../funcs/transformationsUpdateTransformation.js";
import { UpdateRequest$zodSchema } from "../../models/updaterequest.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  transformation: z.string().describe(
    "The transformation identifier. Can be either a named transformation (e.g., 'small_profile_thumbnail') or a transformation string (e.g., 'w_100,h_150,c_fill,g_auto').\n",
  ),
  update_request: UpdateRequest$zodSchema.describe(
    `The updated transformation definition.`,
  ),
};

export const tool$transformationsUpdateTransformation: ToolDefinition<
  typeof args
> = {
  name: "update-transformation",
  description: `Updates the definition of an existing transformation

Updates a named or unnamed transformation.
`,
  scopes: ["admin"],
  annotations: {
    "title": "Update Transformation",
    "destructiveHint": false,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await transformationsUpdateTransformation(
      client,
      args.transformation,
      args.update_request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
